import { render } from "./HomeMobile.vue?vue&type=template&id=27e80f80&scoped=true"
import script from "./HomeMobile.vue?vue&type=script&lang=js"
export * from "./HomeMobile.vue?vue&type=script&lang=js"

import "./HomeMobile.vue?vue&type=style&index=0&id=27e80f80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e80f80"]])

export default __exports__